import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { inventoryLogs } from "../../../../controllers/V1/products/productController";
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../../controllers/common";
import {list as generalData} from "../../../../controllers/V1/cms/generalDataController";
import moment from "moment";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('21:31:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('21:30:00');

  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      const today = new Date();
      let from_date = formData.get('from_date');
      let to_date = formData.get('to_date');

      if(from_date && !to_date){
        to_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      }

      const option = {
        isExport : true,
        condition: {
          ...(formData.get("user_name") && { user_name: formData.get("user_name") } ),
          ...(formData.get("pos_number") && { pos_number: formData.get("pos_number") } ),
          ...(formData.get("mobile") && { mobile: formData.get("mobile") } ),
          ...(formData.get("bind_person_name") && { bind_person_name: formData.get("bind_person_name") } ),
          ...(formData.get("product_name") && { product_name: formData.get("product_name") } ),
          createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`, $lte : `${todayDate} ${todayTime}`}
        },
        select: {
          ...(formData.get("select_user_name")   && { user_name : true } ),
          ...(formData.get("select_pos_number")   && { pos_number : true } ),
          ...(formData.get("select_mobile")   && { mobile : true } ),
          ...(formData.get("select_bind_person_name")   && { bind_person_name : true } ),
          ...(formData.get("select_product_name")   && { product_name : true } ),
          ...(formData.get("select_before")   && { before : true } ),
          ...(formData.get("select_qty")   && { qty : true } ),
          ...(formData.get("select_after")   && { after : true } ),
          ...(formData.get("select_date_time") && { createdAt : true } )
        },
        sort : {_id : -1}
      };

      // Make the API call
      const res = await inventoryLogs(option);
      if (res.status === true) {
        if(res?.result?.length > 0){
          const exportData = await prepareExportData(res.result, option.select);
          
          await exportToExcel(exportData); 
        }
        handleCancel(); 
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  // const prepareExportData = async (listData=[], select={}) => {
  //   const {user_name, pos_number, bind_person_name, product_name, before, quantity, after, createdAt}=select;
  //   if(listData.length > 0){
  //     const result = Promise.all((listData.map((items)=>{
  //       return{
  //         ...((
  //             product_name
  //           ) ? {
  //               ...(user_name && {"Unit"   : items?.user_name}),
  //               ...(pos_number && {"POS no."  : items?.pos_number}),
  //               ...(bind_person_name && {"Bind person name"  : items?.bind_person_name}),
  //               ...(product_name && {"Product name"  : items?.product_name}),
  //               ...(before && {"Old Qty." : items?.before}),
  //               ...(quantity && {"Seller first name" : items?.qty}),
  //               ...(after && {"New Qty."  : items?.after}),
  //               ...(createdAt && {"Created Date"        : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY HH:mm')})
  //             } : {
  //               "User name"  : items?.user_name,
  //               "POS no."  : items?.pos_number,
  //               "Bind person name"  : items?.bind_person_name,
  //               "Product name"         : items?.product_name,
  //               "Old Qty."   : items?.before,
  //               "Qty Added"      : items?.qty,
  //               "New Qty." : items?.after,
  //               "Created Date"        : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY h:mm A')
  //             }
  //           )
  //       }
  //     })));
  //     return result;
  //   }else{
  //     return [];
  //   }
  // }
  const prepareExportData = async (listData = [], select = {}) => {
    if (!Array.isArray(listData) || listData.length === 0) return [];
    
    // detect if at least one checkbox is selected
    const hasCustomSelect = Object.values(select).some(Boolean);
    
    return listData.map((items) => {
    
      /* ---------------- DEFAULT EXPORT ---------------- */
      if (!hasCustomSelect) {
        return {
          "User name": items?.user_name || "",
          "POS no.": items?.pos_number || "",
          "Bind person name": items?.bind_person_name || "",
          "Product name": items?.product_name || "",
          "Old Qty.": items?.before ?? "",
          "Qty Added": items?.qty ?? "",
          "New Qty.": items?.after ?? "",
          "Created Date": moment(
            formatProjectDate(items?.createdAt)
          ).format("DD-MM-YYYY h:mm A")
        };
      }
    
      /* ---------------- CUSTOM EXPORT ---------------- */
      const row = {};
    
      if (select.user_name) {
        row["User name"] = items?.user_name || "";
      }
      if (select.pos_number) {
        row["POS no."] = items?.pos_number || "";
      }
      if (select.bind_person_name) {
        row["Bind person name"] = items?.bind_person_name || "";
      }
      if (select.product_name) {
        row["Product name"] = items?.product_name || "";
      }
      if (select.before) {
        row["Old Qty."] = items?.before ?? "";
      }
      if (select.qty) {
        row["Qty Added"] = items?.qty ?? "";
      }
      if (select.after) {
        row["New Qty."] = items?.after ?? "";
      }
      if (select.createdAt) {
        row["Created Date"] = moment(
          formatProjectDate(items?.createdAt)
        ).format("DD-MM-YYYY HH:mm");
      }
    
      return row;
    });
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Inventory Logs");
      XLSX.writeFile(workbook, `Inventory-Logs_${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
    try {
      const option ={}
      const res = await generalData(option);
      if(res?.status === true){
        const time = moment().endOf('day').format('HH:mm');
        const startTime = res?.result?.export_start_time;
        const endTime = res?.result?.export_end_time;
        setTodayTime(endTime || time);
        setYesterdayTime(startTime || time);
      }
    } catch (error) {
      
    }
  }

  useEffect(()=>{
    getGeneralData();
  },[])

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export Order
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="user_name" className="all_lable_for_vendor_dashbaord">User name :</label>
                    <input type="text" name="user_name" id="user_name" placeholder="User name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="pos_number" className="all_lable_for_vendor_dashbaord">POS no. :</label>
                    <input type="text" name="pos_number" id="pos_number" placeholder="Product name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="bind_person_name" className="all_lable_for_vendor_dashbaord">Bind person name :</label>
                    <input type="text" name="bind_person_name" id="bind_person_name" placeholder="Bind user name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="product_name" className="all_lable_for_vendor_dashbaord">Product name :</label>
                    <input type="text" name="product_name" id="product_name" placeholder="Product name" className="form-control categories_select_tg_enter_product" />
                  </div>
                  
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Date specific (If any) : </label>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      From :
                    </label>
                    <input
                      type="date"
                      name="valid_date"
                      id="valid_date"
                      value={yesterdayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="valid_time"
                      id="valid_time"
                      value={yesterdayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      To :
                    </label>
                    <input
                      type="date"
                      name="expire_date"
                      id="expire_date"
                      value={todayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="expire_time"
                      id="expire_time"
                      value={todayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  

                  {/* Selection Checkboxes for Export */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                  </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_user_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_user_name" id="select_user_name" className="form-check-input" /> User name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_pos_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_pos_number" id="select_pos_number" className="form-check-input" /> POS no.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_bind_person_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_bind_person_name" id="select_bind_person_name" className="form-check-input" /> Bind user name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_product_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_product_name" id="select_product_name" className="form-check-input" /> Product Name
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_before" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_before" id="select_before" className="form-check-input" /> Old Qty.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_qty" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_qty" id="select_qty" className="form-check-input" /> Quantity
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_after" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_after" id="select_after" className="form-check-input" /> New Qty.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_date_time" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_date_time" id="select_date_time" className="form-check-input" /> Created Date & Time
                      </label>
                    </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
